
import { AuthService } from '../services/auth.service';
import { User } from './../models/user';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { MessageService } from '../services/message.service';
import { Router } from '@angular/router';
import { Message } from '../common/message';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  user: User = new User();
  invalidLogin: boolean = false;

  constructor( private router : Router, private authService: AuthService, private dialog: MatDialog, private formBuilder: FormBuilder, private msg: MessageService) { }

  ngOnInit() {
    this.authService.chkIfLoggedIn();
    this.setMessageForm();
  }

  signIn() {

    this.invalidLogin = false;

    this.submitted = true;

    if (!this.user || !this.user.email || this.user.email.trim() == '') {
      return;
    }

    if (!this.user || !this.user.password || this.user.password.trim() == '') {
      return;
    }

    if (this.form.controls.email.errors) {
      return;
    }

    if (this.form.controls.password.errors) {
      return;
    }

    this.authService.login(this.user)
      .subscribe(result => {
        if (result) {
          if(!this.authService.checkActiveUser(result)){
            this.msg.alert(Message.NOT_ACTIVE_USER);
            return;
          } 
          localStorage.setItem('userData', JSON.stringify(result));
          this.msg.alert(Message.SUCCESS_LOGIN);
          this.router.navigate(['/home']);
        } else {
          this.invalidLogin = true;
        }
      }, err=>{
        this.invalidLogin = true;
      })

  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

 
}
